import * as React from 'react';
import { css } from 'office-ui-fabric-react/lib/Utilities';
import * as BaseFieldStyles from '../Field.scss';
import { BaseText } from '../baseText/BaseTextField';

/**
 * @public
 */
export interface IUserFieldUser {
  title: string;
  email: string;
  picture: string;
  sip: string;
  ariaLabel?: string;
}

/**
 * @public
 */
export interface IUserFieldProps {
  users: Array<IUserFieldUser>;
  isDisabled?: boolean;
  isAnonymous?: boolean;
}

/**
 * @public
 */
export const UserField: React.StatelessComponent<IUserFieldProps> = (props: IUserFieldProps) => {
  const { users, isAnonymous, isDisabled } = props;

  if (!users || !users.length) {
    return null; // save dom elements for empty column
  }

  if (isAnonymous) {
    return (
      <div>
        { users.map((user: IUserFieldUser, index: number) => (
          <div key={ index }>
            <BaseText isDisabled={ isDisabled } text={ user.title } />
          </div>
        )) }
      </div>
    );
  }

  return (
    <div>
      {
        users.map((user: IUserFieldUser, index: number) => (
          <BaseText
            isDisabled={ isDisabled }
            key={ index }
            className={ css(`${BaseFieldStyles.field}`, `${BaseFieldStyles.nofill}`) }
            text={ user.title }
          />
        ))
      }
    </div>
  );
};
